import styled from 'styled-components';
import { TableContainer, Th, Td } from './AnalyticsStyles';
import theme from '../../theme';

export const FilterContainer = styled(TableContainer)`
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
`;

export const LeadsTh = styled(Th)`
  white-space: nowrap;
  padding: 0.5rem 13px;
`;

export const LeadsTd = styled(Td)`
  white-space: nowrap;
  padding: 0.75rem 13px;

  /* Override the :first-child style from AnalyticsStyles Td */
  &:first-child {
    white-space: nowrap;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FullWidthInput = styled(FormGroup)`
  grid-column: 1 / -1;
`;

export const FormLabel = styled.label`
  font-family: 'Fustat', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  color: #5a6e83;
  margin-bottom: 0.5rem;
`;

export const FilterInput = styled.input`
  padding: 0.75rem;
  border: 1px solid #dce3eb;
  border-radius: 8px;
  font-family: 'Fustat', sans-serif;
  font-size: 0.95rem;
  color: #333;
  width: 100%;
  box-sizing: border-box;
  
  &::placeholder {
    color: #9db0c4;
  }

  &:focus {
    outline: none;
    border-color: ${theme.colors.bleu_fonce};
    box-shadow: 0 0 0 2px rgba(41, 67, 91, 0.2);
  }
`;

export const FilterButton = styled.button`
  padding: 0.75rem 1.5rem;
  background-color: ${theme.colors.bleu_fonce};
  color: white;
  border: none;
  border-radius: 8px;
  font-family: 'Fustat', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #213547;
  }
`;

// Styles for the domain dropdown
export const DomainSelectorContainer = styled.div`
  position: relative;
`;

export const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #dce3eb;
  border-top: none;
  border-radius: 0 0 8px 8px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 8px 16px rgba(0,0,0,0.1);
`;

export const DropdownItem = styled.div`
  padding: 0.75rem;
  cursor: pointer;
  font-family: 'Fustat', sans-serif;
  font-size: 0.95rem;

  &:hover {
    background-color: #f5f8fa;
  }
`;

export const SelectedItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
`;

export const ItemTag = styled.div`
  display: flex;
  align-items: center;
  background-color: #dce3eb;
  border-radius: 16px;
  padding: 0.3rem 0.8rem;
  font-family: 'Fustat', sans-serif;
  font-size: 0.85rem;
  color: #29435b;
`;

export const CriteriaLabel = styled.span`
  font-weight: 600;
  margin-right: 0.4rem;
`;

export const RemoveTagButton = styled.button`
  background: none;
  border: none;
  color: #5a6e83;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  margin-left: 0.4rem;
  padding: 0;
  line-height: 1;

  &:hover {
    color: ${theme.colors.bleu_fonce};
  }
`;

// Styles for displaying existing filters
export const ExistingFiltersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const FilterItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f7f9fc;
  border: 1px solid #eef1f4;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  font-family: 'Fustat', sans-serif;
  font-size: 0.9rem;
  color: ${theme.colors.bleu_fonce};
`;

export const FilterInfo = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const FilterName = styled.span`
  font-weight: 600;
  white-space: nowrap;
`;

export const FilterCriteriaContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-left: 1rem;
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #9db0c4;
  font-size: 1.25rem;
  font-weight: bold;
  cursor: pointer;
  margin-left: 0.5rem;
  padding: 0 0.25rem;
  line-height: 1;

  &:hover {
    color: ${theme.colors.orange_fonce};
  }
`; 